// material-ui
import { Box } from '@mui/material';

// assets
import logoImage from 'assets/images/logo3.webp';

// ==============================|| LOGO IMAGE ||============================== //

export default function LogoMain() {
  return (
    <Box
      component="img"
      src={logoImage}
      alt="Foire Livre Logo"
      sx={{
        height: 'auto',
        maxHeight: '55px',
        width: 'auto',
        maxWidth: '200px'
      }}
    />
  );
}
